"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Labels = void 0;
var Labels;
(function (Labels) {
    Labels["RequestId"] = "requestId";
    Labels["CorrelationId"] = "correlationId";
    Labels["Authorization"] = "authorization";
    Labels["UnsupportedSub"] = "Not supported currently. Use oid claim.";
})(Labels = exports.Labels || (exports.Labels = {}));
//# sourceMappingURL=Labels.js.map